export default "__VITE_ASSET__CzwngZT2__"